// extracted by mini-css-extract-plugin
export default {"root":"Welcome_root__bckbq","block":"Welcome_block__d82PS","textContainer":"Welcome_textContainer__bC3Dj","buttonContainer":"Welcome_buttonContainer__XNOZB"};